module.exports = __webpack_public_path__ + "img/testimonial-image-02.8e677d6f.jpg";